import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { translate } from "react-i18next";

class DeleteGateway extends Component {
  submitModal = () => {
    const { deleteGateway, modalData } = this.props;
    deleteGateway(modalData);
  };

  render() {
    const { toggleModal, t } = this.props;
    return (
      <React.Fragment>
        <ModalHeader toggle={toggleModal}>
          {t("dashboard.deleteGateway")}
        </ModalHeader>
        <ModalBody>
          <p>{t("dashboard.areYouSureYouWantToDeleteThisGateway")}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={this.submitModal}>
            {t("dashboard.confirm")}
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            {t("dashboard.cancel")}
          </Button>
        </ModalFooter>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteGateway: (data) => dispatch(actions.deleteGateway(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("translations")(DeleteGateway));
